module.exports = "https://cdn.realtymogul.com/static/media/img_panel_homepage_approval.df874ec0.png";